import React from 'react'
import './Registration.css'
import Layout from '../Layout'
import SignupFunction from '../../../utils/CommonFunctionality/SignupFunction'
import SEO from '../../../utils/CommonFunctionality/SEO'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'

const Registration = (props) => {
    const isWizardTheme = document.body.classList[1] == 'wizardTheme'
    const isPrimeBids = global.storeConfigration?.bodyClass?.value == 'primeBids'

    return (
        <>
            {isPrimeBids ? (
                <SEOTAG page="Signup" />
            ) : (
                <SEO title={`${global?.storeDetails?.name} | Signup`} />
            )}
            <Layout>
                <div className="clearfix row regCnt">
                    <div className="col-12">
                        <div className="loginFormBox">
                            <SignupFunction
                                title={!isWizardTheme ? 'Signup' : 'Sign Up'}
                                subTitle="Create your free account today"
                                regpro={props}
                                phone_country_code_must={
                                    global?.storeConfigration?.ten_digit_phone_number?.value == 1
                                        ? 0
                                        : 1
                                }
                            />
                        </div>
                    </div>
                </div>
            </Layout>{' '}
        </>
    )
}

export default Registration
